import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { Store } from '@ngrx/store';
import { CoreActions } from '../stores/actions/core.actions';


@Injectable()
export class EventHostGuard implements CanActivate {
  private readonly _authService = inject(AuthService);
  private readonly _router = inject(Router);
  private readonly _store = inject(Store);

  canActivate(activatedRoute: ActivatedRouteSnapshot) {
    const validToken = this._authService.hasValidToken();
    if (validToken) {
      return this._authService.currentToken?.Permissions.includes('eventHost') ?? false;
    }
    this._store.dispatch(CoreActions.setRedirectURL({ redirectUrl: activatedRoute.url.join('/') }))
        this._router.navigate(["login"]);
    return false;
  }
}